import { errorToast, successToast } from "@design-system/components/toast";
import { telegramLoginAtom } from "@framework/auth/atoms";
import { onSuccessLogin } from "@framework/auth/events";
import { useTrustedDeviceLogin } from "@framework/auth/hooks/use-trusted-device-login.hook";
import { useAction } from "@framework/shared/hooks/useAction";
import { trans } from "@mongez/localization";
import { FormSubmitOptions, getActiveForm } from "@mongez/react-form";

export function useTelegramVerifyOTP() {
  const submit = useAction("/telegram/verify-otp");
  const trustedDeviceLogin = useTrustedDeviceLogin();

  const verifyOTP = async (options: FormSubmitOptions) => {
    const form = getActiveForm();
    form?.submitting(true);
    if (!form) return;

    const values = form.values();

    const result = await submit({
      phoneOrEmail: telegramLoginAtom.get("phoneOrEmail"),
      otpCode: values.otpCode,
      ...(await trustedDeviceLogin.prepareLoginDevice()),
    });

    if (result.isOK) {
      successToast(trans("auth.telegram.loginSuccess"));

      onSuccessLogin(result.data.user);
    } else {
      errorToast(result.error || trans("auth.telegram.otpInvalid"));
      form.submitting(false);
    }
  };

  return {
    verifyOTP,
  };
}
